/**
 * Loads analytics config from the public API and initialises GA4 + FB Pixel.
 * Automatically tracks page views on every route change.
 * Mount once inside <BrowserRouter> so useLocation() works.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { initAnalytics, trackPageView } from "@/lib/analytics";

export default function AnalyticsProvider() {
  const location = useLocation();
  const loaded = useRef(false);

  // Fetch config once and init scripts
  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    api
      .get("/analytics/config")
      .then((res) => {
        if (res.data) initAnalytics(res.data);
      })
      .catch(() => {});
  }, []);

  // Track page view on every navigation
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null; // render-less
}
